import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

// Pages
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import CataloguePage from "./pages/CataloguePage";
import ProductPage from "./pages/ProductPage";
import StorePage from "./pages/StorePage";
import CartPage from "./pages/CartPage";
import OrderPreviewPage from "./pages/OrderPreviewPage";
import CheckoutPage from "./pages/CheckoutPage";
import DashboardPage from "./pages/DashboardPage";
import MyStoresPage from "./pages/MyStoresPage";
// import StoreProductsPage from "./pages/StoreProductsPage";

import SellerDashboardPage from "./pages/SellerDashboardPage";
import ArtisanDashboardPage from "./pages/ArtisanDashboardPage";
import OrdersPage from "./pages/OrdersPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ProfilePage from "./pages/ProfilePage";
import MessagesPage from "./pages/MessagesPage";
import ServiceCheckoutPage from "./pages/ServiceCheckoutPage";

import ReferralsPage from "./pages/ReferralsPage";
import StorePaymentPage from "./pages/StorePaymentPage";
import MonCashCallbackPage from "./pages/MonCashCallbackPage";
import PaiementSuccesPage from "./pages/PaiementSuccesPage";
import PaiementErreurPage from "./pages/PaiementErreurPage";
import "./App.css";

import StoresListPage from "./pages/StoresListPage";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: {
                background: 'white',
                border: '1px solid #e5e7eb',
              },
            }}
          />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/catalogue" element={<CataloguePage />} />
            <Route path="/produit/:productId" element={<ProductPage />} />
            <Route path="/product/:productId" element={<ProductPage />} /> {/* Fallback for English route */}
            <Route path="/boutique/:slug" element={<StorePage />} />
            <Route path="/boutiques" element={<StoresListPage />} />
            <Route path="/panier" element={<CartPage />} />

            {/* Protected Routes */}
            <Route
              path="/store-payment/:storeId"
              element={
                <ProtectedRoute>
                  <StorePaymentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/paiement/callback"
              element={
                <ProtectedRoute>
                  <MonCashCallbackPage />
                </ProtectedRoute>
              }
            />
            <Route path="/paiement/succes" element={<PaiementSuccesPage />} />
            <Route path="/paiement/erreur" element={<PaiementErreurPage />} />
            <Route
              path="/commande/apercu"
              element={
                <ProtectedRoute>
                  <OrderPreviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/service-checkout"
              element={
                <ProtectedRoute>
                  <ServiceCheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mes-boutiques"
              element={
                <ProtectedRoute>
                  <MyStoresPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/seller-dashboard/:storeId"
              element={
                <ProtectedRoute>
                  <SellerDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artisan-dashboard/:storeId"
              element={
                <ProtectedRoute>
                  <ArtisanDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/commandes"
              element={
                <ProtectedRoute>
                  <OrdersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profil"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/messages"
              element={
                <ProtectedRoute>
                  <MessagesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parrainage"
              element={
                <ProtectedRoute>
                  <ReferralsPage />
                </ProtectedRoute>
              }
            />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
